import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import isPlainObject from 'lodash/isPlainObject';
export function getMediaProp(prop, values) {
  if (!prop || !values) {
    return undefined;
  }
  if (!isPlainObject(prop)) {
    return values[prop];
  }
  var mediaKeys = Object.keys(prop);
  var result = {};
  mediaKeys.forEach(function (item) {
    var propValue = prop[item];
    if (propValue) {
      result[item] = values[propValue];
    }
  });
  return result;
}
//# sourceMappingURL=getMediaProp.js.map